/**
 * @generated SignedSource<<93c844d8aa15e1a7baec2c1885d560af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NotificationReadInput = {
  activityFeedbackId?: string | null | undefined;
  clientFormId?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  groupPostComment?: string | null | undefined;
  groupPostId?: string | null | undefined;
  id?: string | null | undefined;
};
export type ActivityResponseItemNotificationReadMutation$variables = {
  input: NotificationReadInput;
};
export type ActivityResponseItemNotificationReadMutation$data = {
  readonly notificationRead: {
    readonly notification: {
      readonly activityFeedbackId: string;
      readonly id: string;
    };
  } | null | undefined;
};
export type ActivityResponseItemNotificationReadMutation = {
  response: ActivityResponseItemNotificationReadMutation$data;
  variables: ActivityResponseItemNotificationReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "NotificationReadPayload",
    "kind": "LinkedField",
    "name": "notificationRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Notification",
        "kind": "LinkedField",
        "name": "notification",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activityFeedbackId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivityResponseItemNotificationReadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActivityResponseItemNotificationReadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7cf59b1d9cbf3dec96e2f6052b6f41f5",
    "id": null,
    "metadata": {},
    "name": "ActivityResponseItemNotificationReadMutation",
    "operationKind": "mutation",
    "text": "mutation ActivityResponseItemNotificationReadMutation(\n  $input: NotificationReadInput!\n) {\n  notificationRead(input: $input) {\n    notification {\n      id\n      activityFeedbackId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f2ffec486c75f332a5de02591dcee6fe";

export default node;
